"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var login_service_1 = require("../_service/login.service");
var user_1 = require("../_model/user");
var i0 = require("@angular/core");
var i1 = require("../_service/login.service");
var i2 = require("@angular/router");
var TenantAdminGuard = /** @class */ (function () {
    function TenantAdminGuard(loginService, router) {
        this.loginService = loginService;
        this.router = router;
    }
    TenantAdminGuard.prototype.canActivate = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.loginService
                .getLoggedInUserRole()
                .toPromise()
                .then(function (role) {
                resolve(role === user_1.UserRole.TENANT_ADMIN);
            });
        });
    };
    TenantAdminGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TenantAdminGuard_Factory() { return new TenantAdminGuard(i0.ɵɵinject(i1.LoginService), i0.ɵɵinject(i2.Router)); }, token: TenantAdminGuard, providedIn: "root" });
    return TenantAdminGuard;
}());
exports.TenantAdminGuard = TenantAdminGuard;
